jQuery(function($) {
  const scrollAdjust = '#header' // スムーズスクロールの補正要素
  // const scrollAdjust = 0  //スムーズスクロールの補正要素
  $('a[href*="#"]')
    .not('.no-move , [target="_blank"]')
    .on('click', function() {
      // アンカーをクリックしたらスクロール
      let href = $(this)
        .attr('href')
        .replace(/.*#/gi, '#') // 同一ページならハッシュ以外を削ってページ遷移を抑止
      autoScroll(href, scrollAdjust)
    })

  if (location.hash) autoScroll(location.hash, scrollAdjust, false) // アクセス時にハッシュがある場合はスクロール
  /**
   * 指定されたセレクタに向かってスクロールを行う
   *
   * @function autoScroll
   * @param  {String} point  移動先のセレクタ
   * @param  {String|Number} adjust 追従ヘッダーの高さを加算し、移動先にヘッダーがかぶらないようにする。ヘッダーのセレクタもしくは数値を入れる
   * @param  {Boolean} [anime=true]  アニメーションの有無
   * @return {Boolean} false
   */

  function autoScroll(point, adjust, anime) {
    if (adjust === undefined) {
      // 未定義なら0
      adjust = 0
    } else if (isNaN(adjust)) {
      // 数値以外でなら要素として高さ取得
      adjust = $(adjust).outerHeight()
    }
    let target = $(point === '#' || point === '' ? 'html' : point)
    if ($(target)[0]) {
      // ターゲットを検出したら実行
      if (anime === true || anime === undefined) {
        // 未定義ならアニメーションさせる
        $('html , body')
          .not(':animated')
          .animate({ scrollTop: target.offset().top - adjust }, 500, 'swing')
      } else {
        $('html , body')
          .not(':animated')
          .animate({ scrollTop: target.offset().top - adjust }, 10, 'linear')
      }
    }
    return false
  }
})
